<script setup>

import {onMounted, reactive, ref} from "vue";

const state = reactive({
    loaded: false,
    status: null,
    userRecentlyCreated: false,
    credentialsToken: null,
})

const displayModal = ref(false)

const pollForCredentials = async () => {
    const keepPollingStates = ['pending'];
    const purchase_uuid = new URLSearchParams(window.location.search).get('purchase_uuid')

    const credentialPoller = setInterval(async () => {
        const res = await axios.get(route('invoice-link.purchase.credentials', [purchase_uuid]))

        state.loaded = true
        state.status = res.data.status
        state.userRecentlyCreated = res.data.user_recently_created
        state.credentialsToken = res.data.credentials_token

        if (! keepPollingStates.includes(res.data.status)) {
            clearInterval(credentialPoller)
            if (res.data.status !== 'not_found') {
                setTimeout(() => {
                    displayModal.value = true
                }, 150)
            }
        }
    }, 700);
}

onMounted(() => {
    pollForCredentials()
})

</script>
<template>
    <div v-if="state.loaded && state.status !== 'logged_in'">
        <div
            class="fixed bottom-0 left-8 right-8 p-4 md:p-6 lg:p-8 bg-white rounded-t-wl shadow-2xl z-modal transition-all duration-1000"
            :class="displayModal ? 'translate-y-0 opacity-100' : 'translate-y-24 opacity-0'"
        >
            <div
                class="text-center relative pb-4"
            >
                <button
                    class="absolute top-0 right-0 -mt-4 -mr-4"
                    @click="displayModal = false"
                >
                    <i class="fa-regular fa-circle-xmark text-2xl text-gray-500 hover:text-gray-700 transition-all duration-200"></i>
                </button>
                <h3 class="mb-2">
                    {{ state.userRecentlyCreated ? _mft('auth:credentials.accountHasBeenCreated') : _mft('auth:credentials.accountAlreadyAvailable') }}
                </h3>
                <div v-if="state.status === 'existing_account_found'">
                    <p>{{ _mft('auth:credentials.accountAlreadyAvailable.byline') }}</p>
                    <p>
                        {{ _mft('auth:credentials.accountAlreadyAvailableResetPasswordPrefix') }}
                        <a
                            :href="route('password.request')"
                            target="_blank"
                        >
                            {{ _mft('auth:credentials.accountAlreadyAvailableResetPasswordLinkText') }}
                        </a>
                    </p>
                </div>
                <div v-if="state.status === 'account_created'">
                    <a
                        :href="route('mfLogin.createNewPassword', state.credentialsToken)"
                        target="_blank"
                    >
                        <button-primary>
                            {{ _mft('auth:credentials.accountCreatedSelectPassword') }}
                        </button-primary>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
